import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

export const COOKIE_KEY = 'gastify_cookie_consent';

export function getCookieConsent() {
  try { return JSON.parse(localStorage.getItem(COOKIE_KEY)); } catch { return null; }
}

function saveConsent(estatisticas) {
  const value = { essenciais: true, estatisticas, data: new Date().toISOString(), versao: 1 };
  try { localStorage.setItem(COOKIE_KEY, JSON.stringify(value)); } catch { /* sem armazenamento */ }
  window.dispatchEvent(new CustomEvent('gastify:cookie-consent', { detail: value }));
}

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState(false);
  const [stats, setStats] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) setOpen(true);
    const reopen = () => { setCustom(true); setOpen(true); };
    window.addEventListener('gastify:cookie-open', reopen);
    return () => window.removeEventListener('gastify:cookie-open', reopen);
  }, []);

  if (!open) return null;
  const decide = (v) => { saveConsent(v); setOpen(false); setCustom(false); };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[90] p-3 sm:p-5 pointer-events-none" role="dialog" aria-label="Aviso de cookies" data-testid="cookie-banner">
      <div className="pointer-events-auto max-w-3xl mx-auto rounded-3xl bg-white shadow-2xl border border-slate-200 p-5 sm:p-6 text-slate-700">
        <div className="flex items-start gap-3">
          <span className="w-10 h-10 rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0"><Cookie size={20} /></span>
          <div className="min-w-0">
            <p className="font-bold text-slate-900">Nós usamos cookies</p>
            <p className="text-sm text-slate-500 mt-1 leading-relaxed">
              Usamos cookies e armazenamento do navegador para o site funcionar e, se você permitir, para entender como ele é usado e melhorá-lo. Saiba mais na{' '}
              <Link to="/cookies" className="font-semibold text-emerald-600 hover:underline">Política de Cookies</Link>.
            </p>
          </div>
        </div>

        {custom && (
          <div className="mt-4 space-y-2.5 text-sm">
            <label className="flex items-start justify-between gap-4 rounded-2xl bg-slate-50 p-3.5">
              <span><strong className="text-slate-800">Essenciais</strong><br /><span className="text-slate-500">Login, segurança, tema e funcionamento do aplicativo. Sempre ativos.</span></span>
              <input type="checkbox" checked disabled className="mt-1 w-4 h-4 accent-emerald-600" />
            </label>
            <label className="flex items-start justify-between gap-4 rounded-2xl bg-slate-50 p-3.5 cursor-pointer">
              <span><strong className="text-slate-800">Estatísticas</strong><br /><span className="text-slate-500">Ajudam a entender quais partes do site são mais usadas.</span></span>
              <input type="checkbox" checked={stats} onChange={(e) => setStats(e.target.checked)} className="mt-1 w-4 h-4 accent-emerald-600" data-testid="cookie-stats" />
            </label>
          </div>
        )}

        <div className="mt-4 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2">
          {custom ? (
            <button onClick={() => decide(stats)} className="rounded-xl bg-slate-900 hover:bg-slate-800 text-white text-sm font-bold px-5 py-2.5" data-testid="cookie-save">Salvar escolhas</button>
          ) : (
            <button onClick={() => setCustom(true)} className="rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-bold px-5 py-2.5" data-testid="cookie-config">Personalizar</button>
          )}
          <button onClick={() => decide(false)} className="rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-bold px-5 py-2.5" data-testid="cookie-reject">Só os essenciais</button>
          <button onClick={() => decide(true)} className="rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold px-5 py-2.5" data-testid="cookie-accept">Aceitar todos</button>
        </div>
      </div>
    </div>
  );
}
